import React, { useEffect, useCallback, useState } from 'react'
import * as actions from '../../reducers/formTable';
import { fetchDispath } from '../../functions/fetch'
import { getEstimateHistory, getEstimateHistoryById, restoreEstimateHistory } from '../../api/estimate'
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableHead, TableRow, TableCell, TablePagination, Typography, IconButton, Collapse, Box, Button } from '@mui/material';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import TablePaginationActionsLeft from '../../components/TablePaginationActionsLeft'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { green, blue } from '@mui/material/colors';

const formName = 'estimate-history'
const useStylesPagination = makeStyles(theme => ({
  toolbar: {
    justifyContent: 'start',
    // border:'2px solid red',
    direction: "rtl"
  },
}));
export default function EstimateHistory({ idProject, loadEstimate, loadGroup }) {
  const dispatch = useDispatch()
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  useEffect(() => {
    dispatch(actions.initFormTable({ name: formName }))
    return () => {
      dispatch(actions.clearFormTable(formName))
    }
  }, [dispatch])
  const loadHistory = useCallback(() => {
    const offset = page * rowsPerPage;
    dispatch(fetchDispath({
      param: {
        id: idProject
      },
      querty: {
        limit: rowsPerPage,
        offset: offset,
      },
      progress: true,
      request: getEstimateHistory,
    }))
      .then(res => {
        dispatch(actions.loadFormTable({ count: res.count, get: res.get }, { name: formName, id: 'id' }))
      }).catch(err => console.log(err))
  }, [dispatch, idProject, page, rowsPerPage])
  const classesPagination = useStylesPagination()
  const allIds = useSelector(state => state.formTable[formName]?.allIds || [])
  const count = useSelector(state => state.formTable[formName]?.count)
  const handlePageChange = (_, newPage) => setPage(+newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    loadHistory();
  }, [loadHistory]);
  return <>
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell>Время</TableCell>
          <TableCell>Тип</TableCell>
          <TableCell>Пользователь</TableCell>
          <TableCell>Количество</TableCell>
          <TableCell>Отменить</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {allIds.map(key => {
          return <TableRowHistory
            key={key}
            id={key}
            idProject={idProject}
            loadHistory={loadHistory}
            loadEstimate={loadEstimate}
            loadGroup={loadGroup}
          />
        })}
      </TableBody>
    </Table>
    <TablePagination
      variant='footer'
      classes={classesPagination}
      rowsPerPageOptions={[4, 10, 25, 50, 100, 500]}
      component="div"
      count={count||0}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleChangeRowsPerPage}
      labelRowsPerPage=''
      labelDisplayedRows={({ from, to, count }) => <Typography component={'span'} style={{ direction: 'ltr' }}>{`${from}-${to} из ${count}`}</Typography>}
      ActionsComponent={
        (props) => {
          // @ts-ignore
          return <TablePaginationActionsLeft {...props} />
        }
      }
    />
  </>
}
function TableRowHistory({ id, idProject, loadHistory, loadEstimate, loadGroup }) {
  const one = useSelector(state => state.formTable[formName]?.byId[id] || {})
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch()
  const loadGroupHistory = useCallback(() => {
    dispatch(fetchDispath({
      param: {
        idProject: idProject,
        id: one.id,
      },
      progress: true,
      request: getEstimateHistoryById,
    }))
      .then(res => {
        dispatch(actions.loadFormTable({ count: res.count, get: res.get }, { name: formName + id, id: 'id' }))
      }).catch(err => console.log(err))
  }, [dispatch, idProject, one.id, id])
  const handleOpen = () => {
    if (!open) {
      loadGroupHistory();
    }
    setOpen(!open)
  }
  const handleRestore = () => {
    dispatch(fetchDispath({
      param: {
        id: idProject,
      },
      body: {
        operationId: one.id
      },
      progress: true,
      request: restoreEstimateHistory,
    }))
      .then(res => {
        loadHistory()
        loadEstimate()
        loadGroup()
      }).catch(err => console.log(err))
  }
  return <>
    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
      <TableCell>
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={handleOpen}
        >
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </TableCell>
      <TableCell>{moment(one.time).format('LLL')}</TableCell>
      <TableCell>{one.type}</TableCell>
      <TableCell>{one.user.name}</TableCell>
      <TableCell>{one.count}</TableCell>
      <TableCell>
        <Button onClick={handleRestore}>Восстановить</Button></TableCell>
    </TableRow>
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <CollapseTable
            formNameProps={formName + id}
            idProject={idProject}
            loadGroupHistory={loadGroupHistory}
            loadEstimate={loadEstimate}
            loadGroup={loadGroup}
          />
        </Collapse>
      </TableCell>
    </TableRow>
  </>
}
const useStyles = makeStyles((theme) => ({
  cellMaterial: {
    color: green[500]
  },
  cellWork: {
    color: blue[500]
  }
}));
function CollapseTable({ formNameProps, idProject, loadGroupHistory, loadEstimate, loadGroup }) {
  const classes = useStyles()
  const allIds = useSelector(state => state.formTable[formNameProps]?.allIds || [])
  const byId = useSelector(state => state.formTable[formNameProps]?.byId || {})
  const dispatch = useDispatch()
  const handleRestore = (id) => {
    dispatch(fetchDispath({
      param: {
        id: idProject,
      },
      body: {
        id: id
      },
      progress: true,
      request: restoreEstimateHistory,
    }))
      .then(res => {
        loadGroupHistory()
        loadEstimate()
        loadGroup()
      }).catch(err => console.log(err))
  }
  return <Box sx={{ margin: 1 }}>
    <Table size="small" aria-label="purchases">
      <TableHead>
        <TableRow>
          <TableCell>Номер</TableCell>
          <TableCell>Тип</TableCell>
          <TableCell>Группа</TableCell>
          <TableCell>Наименование</TableCell>
          <TableCell>Количество</TableCell>
          <TableCell>Отменить</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {allIds.map(key => {
          const one = byId[key]
          return <TableRow key={key}>
            <TableCell>{one.number}</TableCell>
            {(one.type === 'material') ?
              <TableCell className={classes.cellMaterial}>М</TableCell>
              : <TableCell className={classes.cellWork}>Р</TableCell>
            }
            <TableCell>{one.name}</TableCell>
            <TableCell>{one.itemName}</TableCell>
            <TableCell>{one.count}</TableCell>
            <TableCell><Button onClick={() => handleRestore(one.id)}>Восстановить</Button></TableCell>
          </TableRow>
        })}
      </TableBody>
    </Table>
  </Box>
};